// src/components/AccessDenied.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/styles/AccessDenied.css'; // Import the CSS file

const AccessDenied = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <div className="container">
      <h1 className="title">Access Denied</h1>
      <p className="message">You do not have permission to view this page.</p>
      <button className="button" onClick={handleGoBack}>Go Back</button>
    </div>
  );
};

export default AccessDenied;
